import { useContext } from 'react';

import { ConfirmationContext, ContextProps } from 'providers/ConfirmationProvider';

export function useConfirm(): ContextProps {
  return useContext(ConfirmationContext);
}
